export default {
  getDateObj(obj) {
    let date = obj === undefined || obj === null ? new Date() : obj;
    if (typeof date === 'string' && date.indexOf('T') < 0) {
      date = date.replace(/-/g, '/');
    }
    date = typeof date === 'object' ? date : new Date(date);
    return date;
  },
  formatDate(date, fmt) {
    date = this.getDateObj(date);
    fmt = fmt || 'yyyy-MM-dd HH:mm:ss';
    var obj = {
      y: date.getFullYear(), // 年份，注意必须用getFullYear
      M: date.getMonth() + 1, // 月份，注意是从0-11
      d: date.getDate(), // 日期
      q: Math.floor((date.getMonth() + 3) / 3), // 季度
      w: date.getDay(), // 星期，注意是0-6
      H: date.getHours(), // 24小时制
      h: date.getHours() % 12 === 0 ? 12 : date.getHours() % 12, // 12小时制
      m: date.getMinutes(), // 分钟
      s: date.getSeconds(), // 秒
      S: date.getMilliseconds(), // 毫秒
    };
    var week = ['日', '一', '二', '三', '四', '五', '六'];
    for (var i in obj) {
      fmt = fmt.replace(new RegExp(i + '+', 'g'), function (m) {
        var val = obj[i] + '';
        if (i === 'w') return '周' + week[val];
        for (var j = 0, len = val.length; j < m.length - len; j++) {
          val = '0' + val;
        }
        return m.length === 1 ? val : val.substring(val.length - m.length);
      });
    }
    return fmt;
  },

  transDate(date) {
    if (!date) {
      return '';
    }

    date = typeof date === 'object' ? date : new Date(date);
    var today = new Date();

    if (
      today.getTime() - date.getTime() < 0 ||
      today.getFullYear() != date.getFullYear()
    ) {
      // 记录时间超前或不是同年, 显示 yyyy年M月d日
      return this.formatDate(date, 'yyyy年M月d日');
    } else if (
      today.getMonth() != date.getMonth() ||
      today.getDay() != date.getDay()
    ) {
      // 记录为不是同月，不是同周, 显示 M月d日
      return this.formatDate(date, 'M月d日');
    } else if (today.getDay() - date.getDay() > 1) {
      // 记录为同周且不是昨天, 显示 周几
      return this.formatDate(date, 'w');
    } else if (today.getDay() - date.getDay() == 1) {
      // 记录为昨天, 显示 昨天
      return '昨天';
    } else if (
      today.getFullYear() == date.getFullYear() &&
      today.getMonth() == date.getMonth() &&
      today.getDate() == date.getDate()
    ) {
      return this.formatDate(date, 'HH:mm');
    }
    return this.formatDate(date, 'yyyy年M月d日');
  },
  timeFormat(time) {
    let newTime, hour, minite, seconds;
    if (time >= 3600) {
      hour =
        parseInt(time / 3600) < 10
          ? '0' + parseInt(time / 3600)
          : parseInt(time / 3600);
      minite =
        parseInt((time % 60) / 60) < 10
          ? '0' + parseInt((time % 60) / 60)
          : parseInt((time % 60) / 60);
      seconds = time % 3600 < 10 ? '0' + (time % 3600) : time % 3600;
      newTime = hour + ':' + minite + ':' + seconds;
    } else if (time >= 60 && time < 3600) {
      minite =
        parseInt(time / 60) < 10
          ? '0' + parseInt(time / 60)
          : parseInt(time / 60);
      seconds = time % 60 < 10 ? '0' + (time % 60) : time % 60;
      newTime = '00:' + minite + ':' + seconds;
    } else if (time < 60) {
      seconds = time < 10 ? '0' + time : time;
      newTime = '00:' + '00:' + seconds;
    }
    return newTime;
  },
  getAge(birthday) {
    // 新建日期对象
    const date = new Date();
    // 今天日期，数组，同 birthday
    const today = [date.getFullYear(), date.getMonth() + 1, date.getDate()];

    const bd = [
      birthday.getFullYear(),
      birthday.getMonth() + 1,
      birthday.getDate(),
    ];
    // 分别计算年月日差值
    const age = today.map((value, index) => {
      return value - bd[index];
    });
    age[0]++;
    // 当天数为负数时，月减 1，天数加上月总天数
    if (age[2] < 0) {
      // 简单获取上个月总天数的方法，不会错
      const lastMonth = new Date(today[0], today[1], 0);
      age[1]--;
      age[2] += lastMonth.getDate();
    }
    // 当月数为负数时，年减 1，月数加上 12
    if (age[1] < 0) {
      age[0]--;
      age[1] += 12;
    }
    return age[0];
  },
  getDateTime(obj) {
    let date = obj === undefined || obj === null ? new Date() : obj;
    if (typeof date === 'string' && date.indexOf('T') < 0) {
      date = date.replace(/-/g, '/');
    }
    date = typeof date === 'object' ? date : new Date(date);
    return date.getTime();
  },
  dateToAry(date, type) {
    const ret = [];
    type.map((item) => {
      switch (item) {
        case 'year':
          ret.push('' + date.getFullYear());
          break;
        default:
          var v = '';
          switch (item) {
            case 'month':
              v = date.getMonth() + 1;
              break;
            case 'day':
              v = date.getDate();
              break;
            case 'hour':
              v = date.getHours();
              break;
            case 'minute':
              v = date.getMinutes();
              break;
            case 'second':
              v = date.getSeconds();
              break;
          }
          if (v < 10) {
            v = '0' + v;
          } else {
            v = '' + v;
          }
          ret.push(v);
      }
    });
    return ret;
  },
};
